import * as React from "react"
import { type CategorySubtype, type EntityCategory } from "@digits-graphql/frontend/graphql-bearer"
import { type PrimitiveAtom, useAtom, useAtomValue } from "jotai"
import styled from "styled-components"
import {
  InputGroup,
  PanelLabel,
} from "src/frontend/components/OS/Applications/CategoryManager/CategoryPanel/Shared"
import { CATEGORY_SUBTYPE_DISPLAY_MAP } from "src/frontend/components/OS/Applications/CategoryManager/Shared"
import { CATEGORY_ICON_SELECT_CONFIG } from "src/shared/components/Icons/CategoryIconConfig"
import { IconSelect } from "src/shared/components/Icons/IconSelect"

const StyledSelect = styled(IconSelect)`
  width: 80px;
`

interface CategoryIconSelectProps {
  displayKeyAtom: PrimitiveAtom<string | undefined>
  subtypeAtom: PrimitiveAtom<CategorySubtype | undefined>
  parentCategoryAtom: PrimitiveAtom<EntityCategory | undefined>
  disabled?: boolean
}

export const CategoryIconSelect: React.FC<CategoryIconSelectProps> = ({
  displayKeyAtom,
  subtypeAtom,
  parentCategoryAtom,
  disabled = false,
}) => {
  const [hasUserEdited, setHasUserEdited] = React.useState(false)
  const [iconDisplayKey, setIconDisplayKey] = useAtom(displayKeyAtom)
  const parentCategory = useAtomValue(parentCategoryAtom)
  const subtype = useAtomValue(subtypeAtom)

  const selectIcon = React.useCallback(
    (displayKey: string) => {
      setIconDisplayKey(displayKey)
      setHasUserEdited(true)
    },
    [setIconDisplayKey]
  )

  React.useEffect(() => {
    if (!hasUserEdited) {
      setIconDisplayKey(
        subtype ? CATEGORY_SUBTYPE_DISPLAY_MAP.get(subtype)?.displayKey : parentCategory?.displayKey
      )
    }
  }, [disabled, hasUserEdited, parentCategory?.displayKey, setIconDisplayKey, subtype])

  return (
    <InputGroup>
      <PanelLabel>Icon</PanelLabel>
      <StyledSelect
        activeDisplayKey={iconDisplayKey}
        onSelect={selectIcon}
        icons={CATEGORY_ICON_SELECT_CONFIG}
        disabled={disabled}
        required
      />
    </InputGroup>
  )
}
